var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderBordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 294,
    viewBox: "0 0 294 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 293,
    height: 293,
    stroke: "#1689CA",
    strokeDasharray: "20 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderBordered);
export default __webpack_public_path__ + "static/media/placeholder-bordered.11da5c10c2bc40c592df83a9925f4830.svg";
export { ForwardRef as ReactComponent };